import Repo from '../repos/Repo';

export default class STBYLessonRepo extends Repo{

    constructor($auth){
        super($auth, 'stbylessons');
    }

    search(data){
        let url = this.resource + "/search";

        return this.http.post(url + '?include=school', data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }
}


// WEBPACK FOOTER //
// ./src/repos/STBYLessonRepo.js